module.exports = __webpack_public_path__ + "static/media/logo_vib.96c6f77e.svg";